import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

import { Editor } from '@tinymce/tinymce-react';
import { manufacturers } from '../constants';


class ScraperPage extends Component {
    constructor(props) {
        super(props);
        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.changeAttribute = this.changeAttribute.bind(this);
        this.updateScraper = this.updateScraper.bind(this);

        this.state = {
            attributes: {},
            categoryAttributes: [],
        };
    }



    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }


    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('getAdminScraper', (data) => {
            console.log(data);

            this.props.handleLoader(null);

            //data.productAttributes = productAttributes;
            this.setState({
                ...data
            });
        });


        this.props.socketIOClient.on('updateScraper', (data) => {
            this.props.handleLoader(null);

            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/categories/${this.props[0].match.params.cid}`);
            }
        });


        this.props.socketIOClient.on('attributes', (data) => {
            console.log(data);
            this.setState({
                categoryAttributes: data
            });
        });

        
        this.props.socketIOClient.emit('getAdminScraper', { category: this.props[0].match.params.cid });

        this.props.socketIOClient.emit('attributes', { category: this.props[0].match.params.cid });



    }

    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("getAdminScraper");
        this.props.socketIOClient.removeAllListeners("updateScraper");
        this.props.socketIOClient.removeAllListeners("attributes");
    }


    updateScraper() {

        let scraper = {
            title: this.state.title,
            category: this.props[0].match.params.cid,
            price: this.state.price,
            attributes: this.state.attributes,
            shortDescription: this.state.shortDescription,
            description: this.state.description,
            manufacturer: this.state.manufacturer,
            model: this.state.model
        }

        this.props.handleLoader(true);

        this.props.socketIOClient.emit("updateScraper", scraper);
    }


    changeAttribute(attribute, value) {
        let attributes = this.state.attributes;

        attributes[attribute.alias] = attribute;
        attributes[attribute.alias].value = value;


        this.setState({
            attributes: attributes
        });

    }

    render() {




       

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel ">
                <div className="panel-title">
                            <h1>{this.props.translate('Scraper')}</h1>
                            <h6>{this.props.translate('Change fields to edit car')}</h6>

                        </div>

                    <div>



                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Title')}</label>
                            <input type="text" value={this.state.title} onChange={(e) => { this.setState({ title: e.target.value, alias: this.props.generateAlias(e.target.value) }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Short description')}</label>
                            <input type="text" value={this.state.shortDescription} onChange={(e) => { this.setState({ shortDescription: e.target.value }) }} />
                        </div>


                        <div className="spacer"></div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Marka')}</label>
                            <input type="text" value={this.state.manufacturer} onChange={(e) => { this.setState({ manufacturer: e.target.value }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Model')}</label>
                            <input type="text" value={this.state.model} onChange={(e) => { this.setState({ model: e.target.value }) }} />
                        </div>

                        <div className="spacer"></div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Price')}</label>
                            <input type="text" value={this.state.price} onChange={(e) => { this.setState({ price: e.target.value }) }} />
                        </div>

                        <div className="spacer"></div>

                        {
                            this.state.categoryAttributes.map((attribute) => {
                                if (attribute.hidden)
                                    return null;

                                return (
                                    <div className="input-wrap input-wrap-6">
                                    <label>{attribute.name}</label>
                                            <input type="text" value={this.state.attributes[attribute.alias] ? this.state.attributes[attribute.alias].value : null} onChange={(e) => { this.changeAttribute(attribute, e.target.value) }} />
                                        </div>
                                    );

                            }
                            )
                        }

                        <div className="spacer"></div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Description')}</label>
                            <input type="text" value={this.state.description} onChange={(e) => { this.setState({ description: e.target.value }) }} />
                        </div>


                        <div className="input-wrap">
                            <button className="button" onClick={this.updateScraper}>{this.props.translate('Save')}</button>
                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default PageWithLayout(ScraperPage);


// WEBPACK FOOTER //
// ./src/views/scraperPage.js